import { ListMetadata } from './../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoyaltyGiftReservationService {
  baseUrl = '/koncentro-promo';
  divisionId: number;
  search: boolean = false;

  constructor(
    private http: HttpClientService
  ) {}

  getDivisionId(id: number) {
    this.divisionId = id;
  }

  resetData() {
    this.divisionId = undefined;
    sessionStorage.removeItem('divisionId');
    sessionStorage.removeItem('stores');
    sessionStorage.removeItem('selectedGifts');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('customerId');
    sessionStorage.removeItem('customerHostId');
    sessionStorage.removeItem('customerCode');
    sessionStorage.removeItem('customerName');
    sessionStorage.removeItem('customerSurname');
    sessionStorage.removeItem('storeId');
    sessionStorage.removeItem('startingBalance');
    sessionStorage.removeItem('selectedGifts');
    sessionStorage.removeItem('pointsSpent');
    sessionStorage.removeItem('pointsLeft');
    sessionStorage.removeItem('contribution');
    sessionStorage.removeItem('acm');
    sessionStorage.removeItem('acmCode');
    sessionStorage.removeItem('acmId');
    sessionStorage.removeItem('acmDescription');
    sessionStorage.removeItem('cardNo');
    sessionStorage.removeItem('cardId');
    sessionStorage.removeItem('channelCode');
  }

  /**
    * Tramite metodo GET, restituisce la lista dei Premi relativi ad una Division.
    * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
   list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/catalog-gift/getCatalogGiftList?division_sales_network_id=${this.divisionId}&reservation=true&acm_id=${sessionStorage.getItem('acmId')}` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getStores() {
    return this.http.get(`koncentro-common/store?limit=9999`)
  }

  saveReservation(reservationData: any) {
    return this.http.post('koncentro-loyalty/reservation', reservationData);
  }

  saveReservationItem(itemData: any) {
    return this.http.post('koncentro-loyalty/reservation/item', itemData);
  }

  getReservationItem(reservationId: number){
    return this.http.get(`koncentro-loyalty/reservation/item?id=${reservationId}`);
  }

  sendConfirmReservationEmail(id?: number, reservationId?: number, reservationItemId?: number, flagMail?: boolean, giftCode?: string) {
    //let params = {gift_status: 3};
    let params =  {}
    if (id) {
      Object.assign(params, {id});
    }
    if (reservationId) {
      Object.assign(params, {reservation_id: reservationId});
    }
    if (giftCode) {
      Object.assign(params, {gift_item_code: giftCode});
    }
    if(reservationItemId) {
      Object.assign(params, {reservation_item_id: reservationItemId});
      return this.http.get('koncentro-loyalty/reservation/communicationPickupReservationItem', params);
    }
    Object.assign(params, {flagMail});
    return this.http.get('koncentro-loyalty/reservation/communicationConfirmReservation', params);
  }

  sendRemoveReservationEmail(reservationId: number) {
    return this.http.get(`koncentro-loyalty/reservation/communicationRemoveReservationItem/${reservationId}`, {});
  }

  debit(data: any, catalogId:any) {
    return this.http.post(`koncentro-api/kloy/debit?catalogId=${catalogId}`, data);
  }

  credit(data: any, catalogId:any) {
    return this.http.post(`koncentro-api/kloy/credit?catalogId=${catalogId}`, data);
  }

  getCustomerAddress() {
    return this.http.get(`koncentro-customers/v2/customers/${sessionStorage.getItem('customerHostId')}/delivery-address`);
  }

  addAddress(addressData: any) {
    return this.http.post(`koncentro-customers/v2/customers/${sessionStorage.getItem('customerHostId')}/delivery-address`, addressData);
  }

  editAddress(addressData: any, addressId: string) {
    return this.http.put(`koncentro-customers/v2/customers/${sessionStorage.getItem('customerHostId')}/delivery-address/${addressId}`, addressData);
  }

  editCustomerAddress(customerAddressData: any) {
    return this.http.put(`koncentro-customers/v2/customers/${sessionStorage.getItem('customerHostId')}/address`, customerAddressData);
  }

  editCustomerEmailAndMobile(email?: string, mobile?: string) {
    const data = {};
    if (email) {
      Object.assign(data, {email});
    }
    if (mobile) {
      Object.assign(data, {mobile});
    }
    return this.http.put(`koncentro-customers/v2/customers/${sessionStorage.getItem('customerHostId')}/contacts`, data);
  }

  getProvince(provinceCode: string) {
    return this.http.get(`koncentro-common/province/provinces?code=${provinceCode}`);
  }

  getQrCodePrefix(paramKey: string) {
    return this.http.get(`koncentro-loyalty/params/getParam/${paramKey}`);
  }

  getSourceSystemFromStore(storeId: number) {
    return this.http.get(`/koncentro-common/store/getSourceSystemFromStore/${storeId}`);
  }

  getReservationType(){
    return this.http.get('/koncentro-loyalty/params/?param_group=reservation_type');
  }

  getStoresFromDsn(divisionSalesNetworkId: string) {
    return this.http.get(`koncentro-common/store/division_sales_net/${divisionSalesNetworkId}`);
  }

  getStoresByCatalogId(catalogId: string) {
    return this.http.get(`koncentro-api/catalog/stores?catalogId=${catalogId}`);
  }

  getStoresByCodeName(codename: string) {
    return this.http.get(`koncentro-common/store?codename=${codename}`);
  }

  getCatalogGiftItemById(giftId) {
    return this.http.get(`${this.baseUrl}/catalog-gift/item/${giftId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-gift-reservation.service.ts